import React, { useEffect, useState } from 'react';

const Typewriter = ({
  phrases = [],
  startDelayMs = 0,
  typeSpeedMs = 60,
  deleteSpeedMs = 40,
  holdMs = 900,
}) => {
  const [text, setText] = useState('');
  const [phase, setPhase] = useState('idle'); // idle | typing | holding | deleting
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => setPhase('typing'), startDelayMs);
    return () => clearTimeout(timer);
  }, [startDelayMs]);

  useEffect(() => {
    if (phase === 'typing') {
      const full = phrases[index % phrases.length] || '';
      if (text.length < full.length) {
        const t = setTimeout(() => setText(full.slice(0, text.length + 1)), typeSpeedMs);
        return () => clearTimeout(t);
      }
      const t = setTimeout(() => setPhase('holding'), holdMs);
      return () => clearTimeout(t);
    }
    if (phase === 'deleting') {
      if (text.length > 0) {
        const t = setTimeout(() => setText(text.slice(0, -1)), deleteSpeedMs);
        return () => clearTimeout(t);
      }
      setIndex((i) => (i + 1) % phrases.length);
      setPhase('typing');
    }
    if (phase === 'holding') {
      const t = setTimeout(() => setPhase('deleting'), 500);
      return () => clearTimeout(t);
    }
  }, [phase, text, phrases, index, typeSpeedMs, deleteSpeedMs, holdMs]);

  return (
    <span className="typewriter">
      {text}
      <span className="caret" aria-hidden="true" />
    </span>
  );
};

export default Typewriter;


